import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PairChallenge } from '@rocksoft/settings-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const PairConfirmContainerActions = createActionGroup({
  source: 'Pair Confirm Container',
  events: {
    'Verify Code requested': props<{ code: string }>(),
    'Enrollment requested': props<{ challenge: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const PairingApiActions = createActionGroup({
  source: 'Pairing API',
  events: {
    'Verify code valid': props<{ pairChallenge: PairChallenge }>(),
    'Verify code invalid': emptyProps(),
    'Verify code error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// SIGNALR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const PairingSignalRActions = createActionGroup({
  source: 'Pairing SignalR',
  events: {
    'Enrollment completed': props<{ challenge: string }>(),
  },
});
